export default {"src":"/_next/static/media/Group-25841.8bb20464.svg","height":104,"width":104};